module.exports = __webpack_public_path__ + "img/learnReason-tableSm.14c61446.png";